import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { X, GraduationCap, ArrowRight } from "lucide-react";

const BANNER_KEY = "tnn_mc_banner";

export default function MasterclassBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const dismissedPopup = sessionStorage.getItem("tnn_mc_seen");
    const bannerDismissed = sessionStorage.getItem(BANNER_KEY);
    const registered = localStorage.getItem("tnn_mc_registered");
    if (dismissedPopup && !bannerDismissed && !registered) {
      const t = setTimeout(() => setShow(true), 1500);
      return () => clearTimeout(t);
    }
  }, []);

  const dismiss = () => {
    sessionStorage.setItem(BANNER_KEY, "1");
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="masterclass-banner"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 16 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-5 left-1/2 -translate-x-1/2 z-[70] w-[calc(100%-2.5rem)] max-w-xl"
        >
          <div className="bg-tnn-deep text-white rounded-full pl-5 pr-3 py-3 shadow-2xl flex items-center gap-3">
            <span className="w-8 h-8 rounded-full bg-tnn-purple flex items-center justify-center shrink-0">
              <GraduationCap className="w-4 h-4 text-white" />
            </span>
            <p className="text-xs sm:text-sm font-medium text-white/85 flex-1 leading-snug">
              <span className="font-bold text-white">Positioning for Global Leadership</span> · Dec 12 · Live Online ·
              Founding seats $35
            </p>
            <Link
              to="/masterclass"
              data-testid="masterclass-banner-link"
              className="group inline-flex items-center gap-1.5 bg-white text-tnn-deep text-xs font-bold px-4 py-2 rounded-full shrink-0 hover:bg-tnn-lilac transition-colors duration-200"
            >
              Details
              <ArrowRight className="w-3.5 h-3.5 transition-transform duration-200 group-hover:translate-x-0.5" />
            </Link>
            <button
              onClick={dismiss}
              data-testid="masterclass-banner-close"
              aria-label="Dismiss masterclass banner"
              className="w-7 h-7 rounded-full text-white/60 hover:text-white flex items-center justify-center shrink-0 transition-colors duration-200"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
